/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import VideocamIcon from "@mui/icons-material/Videocam";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import { useDispatch } from "react-redux";
import { updateValues } from "../Action/authAction";
import { useLocation } from "react-router-dom";

export default function LiveClassInstructionsPopup(props) {
  const { open, handleClose, handleSubmit, JitSiData, buttonClicked } = props;

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const lastSegment = pathname.split("/").filter(Boolean).pop();

  const videoUrl = {
    obsSetting:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/obsSetting.mp4",
    screenSwitching:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/screenSwitching.mp4",
    micSetting:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/micSetting.mp4",
    unmuteParticipantWithPermission:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/unmuteParticipantWithPermission.mp4",
    unmuteParticipantWithoutPermission:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/unmuteParticipantWithoutPermission.mp4",
    recordingStartedVerification:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/recordingStartedVerification.mp4",
    recordingNotStarted:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/recordingNotStarted.mp4",
    muteAllParticipants:
      "https://media.ifasonline.com/production/Jitsi-class-instructions/muteAllParticipants.mp4",
  };

  const handleVideo = (value) => {
    dispatch(updateValues("videoURL", value));
    window.open("../../instructionsVideo", "_blank");
  };
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modelChat"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="modelInstructions">
            <div className="col d-flex justify-content-between">
              {lastSegment === "dashboard" || lastSegment === "TeacherPanel" ? (
                <h5 className="text-center fw-bolder">
                  <VideocamIcon color="action" style={{ fontSize: "25px" }} />
                  Live Class Instructions
                </h5>
              ) : (
                <h1 className="text-center fw-bolder">
                  <VideocamIcon color="action" style={{ fontSize: "50px" }} />
                  Live Class Instructions
                </h1>
              )}
              {buttonClicked === "instructions" ? (
                <ClearOutlinedIcon
                  className="colorPurple cursor"
                  onClick={() => {
                    handleClose();
                  }}
                />
              ) : null}
            </div>

            <div>
              <div className="modelInstructionsContent">
                <ol>
                  {lastSegment === "dashboard" ||
                  lastSegment === "TeacherPanel" ? (
                    <>
                      <li>
                        <div>
                          <h6 className="fw-bold">
                            ✅ Before You Start the Live Lecture
                          </h6>
                          <div className="d-flex">
                            <div className="col-5">
                              <ol>
                                <li>Turn on your Virtual Camera in OBS.</li>
                                <li>Start Recording in OBS.</li>
                              </ol>
                            </div>
                            <div>
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(videoUrl?.obsSetting)
                                }
                              >
                                <PlayCircleFilledWhiteIcon />
                                OBS Setting
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />

                      <li>
                        <div>
                          <h6 className="fw-bold">
                            🕒 Start the class on time
                          </h6>
                          <div className="d-flex">
                            <div className="col-5">
                              <ol>
                                <li>You may start up to 5 minutes early, or</li>
                                <li>Up to 18 minutes late (maximum).</li>
                              </ol>
                            </div>
                            <div className="d-flex justify-content-between gap-3">
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(
                                    videoUrl?.recordingStartedVerification
                                  )
                                }
                              >
                                <PlayCircleFilledWhiteIcon /> Recording Started
                                Verification
                              </button>
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(videoUrl?.recordingNotStarted)
                                }
                              >
                                <PlayCircleFilledWhiteIcon /> Start Recording
                              </button>
                            </div>
                          </div>
                          <p className="fw-bold alert alert-info m-2">
                            If you start the class more than{" "}
                            <span className="fw-bold text-danger">
                              18 minutes late
                            </span>
                            , please click on{" "}
                            <span className="fw-bolder text-white border bg-success border-success rounded-3 p-2">
                              Start Recording
                            </span>{" "}
                            Button, then you will need to wait an additional{" "}
                            <span className="fw-bolder text-success">
                              5 minutes
                            </span>{" "}
                            for the recording server to initialize.
                          </p>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />
                    </>
                  ) : (
                    <>
                      <li>
                        <div>
                          <h6 className="fw-bold">
                            🕒 Start the class on time
                          </h6>
                          <div className="d-flex">
                            <div className="col-5">
                              <ol>
                                <li>You may start up to 5 minutes early, or</li>
                                <li>Up to 18 minutes late (maximum).</li>
                              </ol>
                            </div>
                            <div className="d-flex justify-content-between gap-3">
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(
                                    videoUrl?.recordingStartedVerification
                                  )
                                }
                              >
                                <PlayCircleFilledWhiteIcon /> Recording Started
                                Verification
                              </button>
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(videoUrl?.recordingNotStarted)
                                }
                              >
                                <PlayCircleFilledWhiteIcon /> Start Recording
                              </button>
                            </div>
                          </div>
                          <p className="fw-bold alert alert-info m-2">
                            If you start the class more than{" "}
                            <span className="fw-bold text-danger">
                              18 minutes late
                            </span>
                            , please click on{" "}
                            <span className="fw-bolder text-white border bg-success border-success rounded-3 p-2">
                              Start Recording
                            </span>{" "}
                            Button, then you will need to wait an additional{" "}
                            <span className="fw-bolder text-success">
                              5 minutes
                            </span>{" "}
                            for the recording server to initialize.
                          </p>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />
                      <li>
                        <div>
                          <h6 className="fw-bold">🎙️ Microphone Settings</h6>
                          <div className="d-flex">
                            <div className="col-5">
                              <ol>
                                <li>
                                  Click on the small <strong>arrow</strong> next
                                  to the Microphone icon (top bar).
                                </li>
                                <li>
                                  Under the <strong>Microphones</strong> list,
                                  select:
                                  <span className="fw-bold text-success">
                                    {" "}
                                    CABLE OUTPUT
                                  </span>
                                  .
                                </li>
                                <li>
                                  Again click the <strong>arrow</strong> next to
                                  the Microphone icon.
                                </li>
                                <li>
                                  Scroll to the bottom and click on{" "}
                                  <strong>Noise Suppression</strong>.
                                </li>
                              </ol>
                            </div>
                            <div>
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(videoUrl?.micSetting)
                                }
                              >
                                <PlayCircleFilledWhiteIcon />
                                Microphone Setting
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />
                      <li>
                        <div>
                          <h6 className="fw-bold">
                            📡 Once the live lecture starts
                          </h6>
                          <div className="d-flex">
                            <div className="col-5">
                              <ol>
                                <li>Go to Settings → Moderator Options</li>
                                <li>Find the option: “Everyone Follows Me”</li>
                                <li>Check the box and click OK.</li>
                              </ol>
                            </div>
                            <div>
                              <button
                                className="btn btn-primary d-flex align-items-center gap-1"
                                onClick={() =>
                                  handleVideo(videoUrl?.screenSwitching)
                                }
                              >
                                <PlayCircleFilledWhiteIcon /> Screen Switching
                              </button>
                            </div>
                          </div>

                          <p className="fw-bold alert alert-info mt-2">
                            Ensures students see only the teacher’s screen,
                            Prevents any accidental switching to other
                            participants’ views & Keeps the focus entirely on
                            the teacher’s presentation.
                          </p>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />
                      <li>
                        <div>
                          <h6 className="fw-bold">
                            🎤 The Mute Controls in Live Class
                          </h6>
                          <ol>
                            <li>Mute All Button (Before Class Starts):</li>
                            <div className="d-flex mb-2">
                              <div className="col-5">
                                <ul>
                                  <li className="mt-2">
                                    Click the{" "}
                                    <span className="fw-bold text-dark border bg-default border-dark rounded-3 py-1 px-2">
                                      Mute All
                                    </span>{" "}
                                    button, to set the class’s audio behavior
                                    and decide whether students can unmute
                                    themselves or not.
                                  </li>
                                </ul>
                              </div>
                              <div className="d-flex justify-content-between gap-3">
                                <button
                                  className="btn btn-primary d-flex align-items-center gap-1"
                                  onClick={() =>
                                    handleVideo(
                                      videoUrl?.unmuteParticipantWithPermission
                                    )
                                  }
                                >
                                  <PlayCircleFilledWhiteIcon /> Unmute With
                                  Permission
                                </button>
                                <button
                                  className="btn btn-primary d-flex align-items-center gap-1"
                                  onClick={() =>
                                    handleVideo(
                                      videoUrl?.unmuteParticipantWithoutPermission
                                    )
                                  }
                                >
                                  <PlayCircleFilledWhiteIcon /> Unmute Without
                                  Permission
                                </button>
                              </div>
                            </div>
                            <li>
                              Mute Participants Button (Regular Use During
                              Class):
                            </li>

                            <div className="d-flex">
                              <div className="col-5">
                                <ul>
                                  <li className="mt-2">
                                    Use{" "}
                                    <span className="fw-bold text-white border bg-secondary border-secondary rounded-3 py-1 px-2">
                                      Mute Participants
                                    </span>{" "}
                                    button, whenever the teacher needs to mute
                                    all students without affecting teacher
                                    audio.
                                  </li>
                                </ul>
                              </div>
                              <div>
                                <button
                                  className="btn btn-primary d-flex align-items-center gap-1"
                                  onClick={() =>
                                    handleVideo(videoUrl?.muteAllParticipants)
                                  }
                                >
                                  <PlayCircleFilledWhiteIcon /> Mute All
                                  Participants
                                </button>
                              </div>
                            </div>
                          </ol>
                        </div>
                      </li>
                      <hr className="border-top border-3 border-secondary" />
                    </>
                  )}
                </ol>
                {(lastSegment === "dashboard" ||
                  lastSegment === "TeacherPanel") &&
                buttonClicked === "start" ? (
                  <button
                    className="mx-auto btn btn-sm btn-primary d-flex align-items-center gap-1"
                    onClick={() => {
                      handleSubmit(
                        JitSiData?.item,
                        JitSiData?.lectureType,
                        JitSiData?.isFree
                      );
                      handleClose();
                    }}
                  >
                    Proceed
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
